import React from 'react'
import { ArrowDown2 } from 'iconsax-react'
import { useTheme } from '@mui/material'

import ButtonMenu from '../../../ButtonMenu'

import useStyles from './styles'

const PageSize = ({ rowsPerPage, onChangeRowsPerPage, paginationOptions }) => {
  const theme = useTheme()

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <ButtonMenu
        options={paginationOptions}
        onSelect={onChangeRowsPerPage}
        selected={rowsPerPage}
        className={classes.children}
      >
        <div className={classes.menu}>{rowsPerPage}</div>

        <ArrowDown2
          size={theme.size.base}
          variant='Bold'
          className={classes.icon}
        />
      </ButtonMenu>

      <div className={classes.text}>RESULTS PER PAGE</div>
    </div>
  )
}

export default PageSize
